import './SelectListSingle.css'
import React from 'react'
import cx from 'classnames'
import { Radio, radioCheckboxClasses } from '../RadioGroup/RadioGroup'
import { Label } from '../InputLabel/InputLabel'

function RadioSelectListItem<T extends string | boolean | number>({
  label,
  id,
  value,
  name,
  children,
  onChange,
  isChecked,
  disabled,
  isOpen,
  tooltip,
  tooltipPlacement,
  tooltipSize
}: {
  id: string
  label: string
  name: string
  onChange?: (value: T) => void
  value: T
  isChecked: boolean
  children?: React.ReactNode
  isOpen?: boolean
  disabled?: boolean
  tooltip?: React.ReactNode
  tooltipPlacement?: 'top' | 'bottom'
  tooltipSize?: 'small' | 'medium' | 'large'
}) {
  return (
    <div
      className={cx(
        'select-list-item',
        isChecked && !disabled ? 'select-list-item-checked' : 'select-list-item-default'
      )}
    >
      <Label
        htmlFor={id}
        className={cx(
          'select-list-item-label',
          !isOpen && 'select-list-item-label-closed',
          isChecked && !disabled && 'select-list-item-label-checked',
          isChecked && disabled && 'select-list-item-label-disabled',
          !isChecked && !disabled && 'select-list-item-label-hover',
          {
            disabled: disabled
          }
        )}
        tooltip={tooltip}
        tooltipPlacement={tooltipPlacement}
        tooltipSize={tooltipSize}
      >
        <Radio
          disabled={disabled}
          id={id}
          name={name}
          isChecked={isChecked}
          value={value}
          onChange={onChange}
        />
        <span className={cx(radioCheckboxClasses.label, disabled && 'text-text-secondary')}>
          {label}
        </span>
      </Label>
      {isOpen && <div className="select-list-item-children">{children}</div>}
    </div>
  )
}

export function SelectListSingle<T extends string | boolean | number>({
  className,
  name,
  disabled,
  onChange,
  items
}: {
  name: string
  className?: string
  onChange?: (value: T) => void
  disabled?: boolean
  items: {
    id: string
    label: string
    isChecked: boolean
    disabled?: boolean
    value: T
    tooltip?: React.ReactNode
    tooltipPlacement?: 'top' | 'bottom'
    tooltipSize?: 'small' | 'medium' | 'large'
    children?: React.ReactNode
    isOpen?: boolean
  }[]
}) {
  return (
    <div className={className}>
      {items.map(item => (
        <RadioSelectListItem
          key={item.id}
          id={`${name}:${item.id}`}
          name={name}
          label={item.label}
          value={item.value}
          disabled={item.disabled || disabled}
          isChecked={item.isChecked}
          isOpen={item.isOpen}
          onChange={onChange}
          tooltip={item.tooltip}
          tooltipPlacement={item.tooltipPlacement}
          tooltipSize={item.tooltipSize}
        >
          {item.children}
        </RadioSelectListItem>
      ))}
    </div>
  )
}
